const KLAVIYO_FORM_IDS = ['U5eLLW', 'VTTwrA', 'SYjXcA'];
window.addEventListener('klaviyoForms', function (e) {
  if (!e.detail || e.detail.type !== 'submit') return;

  const email_ = e.detail.metaData.$email;
  var eventName = 'signupBox'
  const formId = e.detail.formId;
  if (!KLAVIYO_FORM_IDS.includes(formId)) return;

  const metaData = e.detail.metaData || {};

  if (typeof TriplePixel === "function") {
    const payload = {
      formId: formId,
      pageUrl: window.location.href,
      email: email_
    }

    try {
      const product = window.ShopifyAnalytics
        && window.ShopifyAnalytics.meta
        && window.ShopifyAnalytics.meta.product;
      if (product && product.id) {
        payload.productId = String(product.id);
        eventName = 'signupBoxProduct'
      }
    } catch (err) {
      console.log('TriplePixel signupBox not on PDP:', err);
    }

    payload.formType = eventName;
    TriplePixel('custom', eventName, payload);
  }
});
